import React, { Component } from 'react';
import { Container, Segment, Grid, Image, Card, Divider, Header } from 'semantic-ui-react';

const Publication = (props) => (
  <Card onClick={props.onChangeCurrentBook}>
	  <Image src={props.img_url} style={{ height: "350px", width: "auto", margin: "15px auto"}}/>
	  <Card.Content style={{textAlign: "center"}}>
	  	<Card.Header >{props.title}</Card.Header>
	  </Card.Content>
  </Card>
);



class Publications extends Component {
	constructor(props) {
		super(props);

		this.state = { };
		this.changeCurrentBook = this.changeCurrentBook.bind(this);

	}

	changeCurrentBook(e) {
		this.setState({ currentBook: e });
		window.scroll(0,0);
	}

  render() {
  	return(
			<Segment basic>
				<Container>
					<Grid stackable>
						<Grid.Row divided>
							<Grid.Column width={8}>
								<Image src={ this.state.currentBook ? this.state.currentBook.img_url : this.props.publicationType[0].img_url } centered/>
							</Grid.Column>
							<Grid.Column width={8} verticalAlign="middle">
								<Header content={ this.state.currentBook ? this.state.currentBook.title : this.props.publicationType[0].title } />
								<p>{ this.state.currentBook ? this.state.currentBook.blurb : this.props.publicationType[0].blurb }</p>
							</Grid.Column>
						</Grid.Row>
					</Grid>
					<Grid.Row>
					<Divider />
					<Grid.Column>
						<Card.Group itemsPerRow={4} doubling stackable>
							{ this.props.publicationType.map((publication) => {
								  return (
								  	<Publication 
								  		title={publication.title}
								      blurb={publication.blurb}
								      img_url={publication.img_url}
								      key={publication.title}
								      onChangeCurrentBook={ () => this.changeCurrentBook(publication) }
								    />
								  )
								}) 
							}
						</Card.Group>
					</Grid.Column>
					</Grid.Row>
				</Container>
			</Segment>
		);
	}
}

export default Publications;


// WEBPACK FOOTER //
// ./src/components/Publications.js